<div class="indicateur-bureau" [class.hovered]="declencherHoverIndicateurBureau()"
	 [ngClass]="classePourBackgroundColorBureau()">
	<i class="icone"
	   [pTooltip]="tooltip()"
	   [ngClass]="iconeOccupationPourHtml()"></i>
</div>
